import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import SearchTileStackInclusionsList from '../shared/SearchTileStackInclusionsList'
import ModalContext from 'contexts/ModalContext'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import useLoyaltyBenefitInclusions from 'loyalty/hooks/useLoyaltyBenefitInclusions'

interface Props {
  offer: App.BundleOffer
  offerMetaData?: App.OfferListMetaData
  filters?: App.OfferListFilters

}

function HotelBundleSearchTileFeatures({ offer, offerMetaData, filters }: Props) {
  const intl = useIntl()
  const offerUrl = useOfferUrl(offer, {
    filters,
    bundledOfferId: offerMetaData?.bundledOfferId,
    offerLinkIncludesFilters: true,
  })
  const showModal = useContext(ModalContext)
  const loyaltyCount = useLoyaltyBenefitInclusions(offer).length

  const openInclusionsModal = useCallback(() => {
    showModal(<Modal
      title=""
      primaryActionText={intl.formatMessage({
        id: 'fE5GIl6sB5ywqYZgR8Lf',
        defaultMessage: 'View offer',
      })}
      primaryActionTo={offerUrl}
    >
      <Group direction="vertical" gap={4}>
        {!!offer.tileInclusions?.length && <OfferInclusionsList inclusions={offer.tileInclusions} />}
        <LoyaltyInclusions offer={offer} variant="offer-page" />
      </Group>
    </Modal>)
  }, [offer, offerUrl, showModal, intl])

  if (!offer.tileInclusions?.length) return null

  return (
    <SearchTileStackInclusionsList
      inclusions={offer.tileInclusions}
      inclusionsTitle={offer.tileInclusionsHeading}
      onShowMoreClick={openInclusionsModal}
      additionalHiddenCount={loyaltyCount}
    />
  )
}

export default HotelBundleSearchTileFeatures
